import { useState } from "react";
import DashboardLayout from "../../../../Layout/DashboardLayout";
import { Link, useNavigate, useParams } from "react-router-dom";
import BasicInformation from "../Components/BasicInformation";
import { useGetProductsQuery } from "../../../../hooks/ProductsManagement/useGetProductsQuery";
import Loader from "../../../../Components/Loader";
import NairaSign from "Components/NairaSign";
import CommaFormat from "Components/CommaFormat";
import { Modal } from "antd";
import EditCatalogProduct from "./EditComponents/EditCatalogProduct";
import KoboConverter from "Components/KoboConverter";

const CatalogPeview = () => {
  const navigate = useNavigate();

  interface Category {
    name: string;
    id: string;
  }

  const { id } = useParams();
  const { data, isFetching } = useGetProductsQuery({ id });

  const goBack = () => {
    navigate(-1);
  };

  // const [active, setActive] = useState(0);
  const [selectedCatalog, setSelectedCatalog] = useState<any>({});
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  return (
    <DashboardLayout title="Product Details" back={false}>
      {isFetching && <Loader />}
      {!isFetching && data && (
        <div>
          <div className="ml-[20px] mr-[14px] mt-[20px] py-[10px]">
            <span
              className="flex gap-2 items-center cursor-pointer"
              onClick={goBack}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
                />
              </svg>
              <span>Back</span>
            </span>
          </div>
          <div className="flex ml-[20px] gap-[10px]">
            <div className="w-3/12">
              <img
                src={
                  data && data?.data?.images
                    ? data?.data?.images[0]
                    : "https://via.placeholder.com/500"
                }
                alt="product preview"
                className="w-full h-[350px] border-[1px] border-[#eeeeee]"
              />
            </div>
            <div className="w-9/12">
              <h3 className="text-[25px] mb-[15px] font-medium">
                {data?.data?.name}
              </h3>
              <div className="text-[#A8A8A8]">
                {data?.data?.categories.map(
                  (
                    { name, id }: Category,
                    index: number,
                    array: Category[]
                  ) => (
                    <span key={id}>
                      {name}
                      {index < array.length - 1 && ", "}
                    </span>
                  )
                )}
                <div className="w-10/12">
                  <div className=" mb-[11px] mt-[37px]">
                    <div className="text-[#a8a8a8]">Total</div>
                    <div className="w-4/12 text-black font-bold text-[25px]">
                      <KoboConverter amount={data?.data?.unitPrice} />
                    </div>
                    <div className="mt-5">
                      <Link
                        to={`/product-management/${id}/edit`}
                        className="p-2 rounded-md border-orange border text-orange"
                      >
                        Edit Product
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              {/* <div className="border-b-[1px] border-t-[1px] border-[#eeeeee] mb-3 mt-[21px]">
                <div
                  className={`px-[20px] py-[26px] cursor-pointer ${
                    active === 0 ? "text-orange bg-[#FFF5F0]" : "text-[#a8a8a8]"
                  }`}
                  onClick={() => setActive(0)}
                >
                  Basic Information
                </div>
              </div> */}
            </div>
          </div>
          <div className="ml-[29px] mr-[29px] mt-[20px]">
            <div className="border-b-[1px] border-t-[1px] border-[#eeeeee] mb-3 mt-[21px]">
              <div
                className="px-[20px] py-[26px] text-orange bg-[#FFF5F0]"
                // onClick={() => setActive(0)}
              >
                Basic Information
              </div>
            </div>

            <BasicInformation product={data} />
            {/* {active === 1 && <ProductImage product={data?.data} />} */}
            {/* {active === 2 && <ShippingInformation product={data?.data} />} */}
          </div>
          <Modal
            title={`Edit ${selectedCatalog?.name && selectedCatalog?.name}`}
            open={isEditModalOpen}
            onCancel={() => {
              setIsEditModalOpen(false);
            }}
            footer={null}
          >
            <div>
              <EditCatalogProduct selectedCatalog={selectedCatalog} />
            </div>
          </Modal>
        </div>
      )}
    </DashboardLayout>
  );
};

export default CatalogPeview;
